import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer";
import { NavBar } from "../../components/navBar";

export const Loading = () => {
  const { t } = useTranslation();
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        background:
          "linear-gradient(180deg, #1A0F2E 0%, #17092E 50%, #1A0F2E 100%)",
      }}
    >
      <NavBar />
      <main className="flex-grow pt-[70px] px-6 py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-white mb-6">
            {t("pages.profile.title", "Il Mio Profilo")}
          </h1>
          <p className="text-white/80">
            {t(
              "pages.profile.loading",
              "Caricamento delle tue informazioni..."
            )}
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};
